module.exports = __webpack_public_path__ + "static/media/equipment.3484132d.svg";